import { render, staticRenderFns } from "./salesTacticstable.vue?vue&type=template&id=28354cf0&scoped=true&"
import script from "./salesTacticstable.vue?vue&type=script&lang=js&"
export * from "./salesTacticstable.vue?vue&type=script&lang=js&"
import style0 from "./salesTacticstable.vue?vue&type=style&index=0&id=28354cf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28354cf0",
  null
  
)

export default component.exports